const formatSize = (attr) =>
  attr.key === 'size'
    ? { size: { key: attr.value, label: attr.value } }
    : { [attr.key]: attr.value };

export const parseProducts = (responseData, placement = null) =>
  responseData?.map(
    ({
      url,
      custom_fields = [],
      alternate_image_urls: alternateImageUrls,
      product_id: productId,
      image_url: imageUrl,
      price,
      name,
      skus,
    }) => {
      const attributes = Object.entries(custom_fields).map(([key, value]) => ({
        key,
        value,
      }));

      const priceLength = price.toString().length;
      const objectUrl = new URL(url);
      const siblings = attributes.find(
        (attribute) => attribute.key === 'siblingsreferences',
      );
      const initialColor = attributes.find(
        (attribute) => attribute.key === 'colour',
      );
      const pricesAttr = attributes.find(
        (attribute) => attribute.key === 'prices',
      );
      const vipPricesAttr = attributes.find(
        (attribute) => attribute.key === 'vip_prices',
      );
      const discountsAttr = attributes.find(
        (attribute) => attribute.key === 'discounts',
      );
      const productimagebadge = attributes.find(
        (attribute) => attribute.key === 'productimagebadge',
      );
      const primaryCategory = attributes.find(
        (attribute) => attribute.key === 'primarycategory',
      );
      const newarrival = attributes.find(
        (attribute) => attribute.key === 'newarrival',
      );
      const swatchImage = attributes.find(
        (attribute) => attribute.key === 'swatch_image',
      );
      const prices = pricesAttr?.value && JSON.parse(pricesAttr.value);
      const vipPrices =
        (vipPricesAttr?.value && JSON.parse(vipPricesAttr.value)) || [];
      const discounts =
        (discountsAttr?.value && JSON.parse(discountsAttr.value)) || [];
      const badge = productimagebadge?.value.split(',') || [];
      // if valid json then parse sibling and cound ids
      let siblingJson = null;
      if (siblings && siblings.value) {
        try {
          const siblingData = JSON.parse(siblings.value);
          siblingJson = siblingData?.length
            ? siblingData
            : siblingData instanceof Object
            ? Object.values(siblingData)
            : [];
          siblingJson = siblingJson.filter((item) => !!item.swatch);
        } catch (e) {
          console.error(e);
        }
      }

      const colours =
        siblingJson && siblingJson.length + 1 > 1
          ? `${siblingJson.length + 1} Colours`
          : initialColor?.value;
      const tags = [colours, ...badge];

      const variants = skus.map((item) => {
        const _attributes = Object.entries(item.custom_fields).map(
          ([key, value]) => ({
            key,
            value,
          }),
        );
        return {
          ...item,
          isOnStock: item.available,
          sku: item.name,
          attributes: {
            ..._attributes.reduce(
              (acc, curr) => ({ ...acc, ...formatSize(curr) }),
              {},
            ),
            swatch_image: swatchImage?.value ?? null,
          },
        };
      });

      const mainImage = {
        id: productId,
        url: imageUrl,
      };
      return {
        images: alternateImageUrls?.filter(Boolean)?.length
          ? [
              mainImage,
              ...alternateImageUrls.map((image) => ({
                id: productId,
                url: image,
              })),
            ]
          : [mainImage],
        regularPrice: priceLength < 5 && price * 100,
        productName: name,
        label: newarrival?.value === 'true' ? 'New' : '',
        url: objectUrl?.pathname,
        projectSpecificData: {
          prices,
          primaryCategory: primaryCategory?.value,
          vipPrices,
          discounts,
          siblings: siblingJson,
          images: swatchImage?.value
            ? [
                {
                  label: 'swatch',
                  url: swatchImage?.value,
                },
              ]
            : [],
        },
        productId,
        skus,
        tags,
        variants,
        type: 'nostoProduct',
        placement: placement,
      };
    },
  );
